import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonHTMLAttributes } from 'react';

export type ButtonStyle = 'borderless' | 'outline' | 'primary' | 'default';

export type ButtonProps = {
    variant: ButtonStyle;
    icon?: IconDefinition;
    text: string;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const Button = ({ variant, icon, text, ...props }: ButtonProps) => {
    switch (variant) {
        case 'borderless':
            return (
                <button {...props} className={`py-2 group ${props.className}`}>
                    {icon && <FontAwesomeIcon icon={icon} fixedWidth className='text-loving-500 mr-2' />}
                    <span className='text-sm font-medium text-gray-700 group-hover:text-loving-500'>{text}</span>
                </button>
            )
        case 'outline':
            return (
                <button {...props} className={`btn-outline ${props.className}`}>
                    {icon && <FontAwesomeIcon icon={icon} className={`${props.disabled ? 'text-gray-400' : 'text-loving-500'} mr-2`} />}
                    <span className='text-sm font-medium'>{text}</span>
                </button>
            );
        case 'primary':
            return (
                <button {...props} className={`btn btn-primary ${props.className}`}>
                    {text}
                </button>
            );
        case 'default':
        default:
            return (
                <button {...props} className={`btn ${props.className}`}>
                    {text}
                </button>
            );
    }
}